import { render } from "./FooterLayout.vue?vue&type=template&id=4ff14f7b&scoped=true"
const script = {}

import "./FooterLayout.vue?vue&type=style&index=0&id=4ff14f7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff14f7b"]])

export default __exports__